import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { FactoryExportsDashboardQueryKeys } from "modules/FactoryExportsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { FactoryExportID } from "models";

type DeleteExportPayload = {
  factory_export_id: FactoryExportID;
};

export const useDeleteExportMutation = () =>
  useTypedMutation<DeleteExportPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/exports/delete", payload, ENV.reportsBaseURL);
    },
    onSuccess: ({ factory_export_id }) => {
      const exports = typedQueryClient.getQueryData(FactoryExportsDashboardQueryKeys.exports);
      if (!exports) return;

      const exportIdx = exports.findIndex(factoryExport => factoryExport.id === factory_export_id);
      if (exportIdx === -1) return;

      typedQueryClient.setQueryData(FactoryExportsDashboardQueryKeys.exports, exports.toSpliced(exportIdx, 1));
    }
  });
